
const overlay = function({
    openTriggerSelector = '.header-utils-overlay--btn-open',
    closeTriggerSelector = '.header-utils-overlay--btn-close',
    overlayId = 'header-utils-overlay',
    openedClass = 'header-utils-overlay-open',
    closedClass = 'header-utils-overlay-close',
    animationName = 'header-utils-overlay-fade-out',
  } = {} ) {
    /**
     * Navigation overlay opener and closer
     */
  
    const overlayOpenTriggers = document.querySelectorAll(
        openTriggerSelector);
    const overlayCloseTriggers = document.querySelectorAll(
        closeTriggerSelector);
  
    const overlay = document.getElementById(overlayId);
  
    overlayOpenTriggers.forEach((element) => {
      element.addEventListener('click', function(event) {
        if (overlay) {
          event.preventDefault();
          overlay.classList.remove(closedClass);
          overlay.classList.add(openedClass);
        }
      });
    });
  
    overlayCloseTriggers.forEach((element) => {
      element.addEventListener('click', function(event) {
        if (overlay) {
          event.preventDefault();
          overlay.classList.add(closedClass);
        }
      });
    });
  
    if (overlay) {
      overlay.addEventListener('animationend', function(event) {
        if (event.animationName === animationName) {
          overlay.classList.remove(openedClass);
          overlay.classList.remove(closedClass);
        }
      });
    }
  };
  
  export default overlay;
  